import { defineMessages } from "@edx/frontend-platform/i18n";

const messages = defineMessages({
  home: {
    id: 'mobile.dashboard.page.home',
    defaultMessage: 'Home',
    description: 'Home page',
  },
  discover: {
    id: 'mobile.dashboard.page.discover',
    defaultMessage: 'Discover',
    description: 'Discover page',
  },
  myLearning: {
    id: 'mobile.dashboard.page.my-learning',
    defaultMessage: 'My Learning',
    description: 'My Learning page',
  }
});

export default messages;